import { ChangeEvent, FC, useState, useRef, useEffect } from 'react';
import { Icon } from 'common-components';
import { IconButton } from '../../uiLibraryImports';
import { FileTypes, LogoActions } from './uploadFileTypes';
import styles from './uploadFile.module.scss';

const UploadFile: FC<UploadFileProps> = (props: UploadFileProps) => {
    const {
        deleteTitle,
        replaceTitle,
        onDelete,
        onUpload,
        fileType = FileTypes.IMAGE,
        hoverTitle,
        hoverImage,
        logo
    } = props;

    const [isHovered, setIsHovered] = useState<boolean>(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const ref = useRef() as React.MutableRefObject<HTMLInputElement>;
    const [showActions, setShowActions] = useState<boolean>(false);

    const handleReplaceORDelete = (action: LogoActions) => {
        if (action === LogoActions.REPLACE) {
            fileInputRef?.current?.click();
        }
        if (action === LogoActions.DELETE) {
            onDelete();
        }
        setShowActions(false);
    };

    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {
            if (showActions && ref.current && !ref.current.contains(e.target)) {
                setShowActions(false);
            }
        };

        document.addEventListener('mousedown', checkIfClickedOutside);

        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [showActions]);

    return (
        <div className={styles.container}>
            {logo && <img alt="logo" src={logo} className={styles.logo} />}
            <label htmlFor="icon-file-upload-button">
                <IconButton
                    className={styles['input-wrapper']}
                    onClick={() => setShowActions(true)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {hoverTitle && isHovered && <span className={styles['hover-title']}>{hoverTitle}</span>}
                    {hoverImage && isHovered && <Icon name="uploadImage" className={styles['image-container']} />}
                    <input
                        id="upload-file"
                        accept={`${fileType}/*`}
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={onUpload}
                        data-testid="upload-image-testid"
                    />
                </IconButton>
                {showActions && (
                    <div className={styles['logo-options-wrapper']} ref={ref}>
                        <div className={styles.options} onClick={() => handleReplaceORDelete(LogoActions.REPLACE)}>
                            <Icon name={'replaceGrey'} className={styles.icon} />
                            <div className={styles['options-text']}>{replaceTitle}</div>
                        </div>
                        <div className={styles.options} onClick={() => handleReplaceORDelete(LogoActions.DELETE)}>
                            <Icon name={'trashGrey'} className={styles.icon} />
                            <div className={styles['options-text']}>{deleteTitle}</div>
                        </div>
                    </div>
                )}
            </label>
        </div>
    );
};

interface UploadFileProps {
    onUpload: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
    onDelete: () => void;
    fileInput?: any;
    fileType?: string;
    hoverTitle?: string;
    hoverImage?: boolean;
    logo?: string;
    deleteTitle: string;
    replaceTitle: string;
}

export default UploadFile;
